<script setup lang="ts"></script>

<template>
  <div>
    <svg height="200" viewBox="0 0 280 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="134.881"
        y="17.326"
        width="81.4285"
        height="144.964"
        rx="10.0783"
        fill="white"
        stroke="currentColor"
        stroke-width="4.65153"
      />
      <rect x="167.431" y="28.4022" width="20.1566" height="4.65153" rx="2.32576" fill="currentColor" />
      <rect x="159.678" y="28.4022" width="4.65153" height="4.65153" rx="2.32576" fill="currentColor" />
      <path
        d="M136.421 76.4687C136.421 76.4687 136.214 74.4963 135.532 72.223C133.148 64.2641 125.095 70.9134 122.886 78.9228C121.105 85.378 120.82 92.8476 125.535 97.6033C127.848 99.9365 130.578 101.085 133.32 98.9518C138.902 94.6103 137.713 82.1541 136.421 76.4687Z"
        fill="white"
      />
      <path
        d="M110.498 139.898L108.192 140.202L108.194 140.212L108.195 140.222L110.498 139.898ZM111.671 118.239L113.904 118.891L113.907 118.879L113.911 118.866L111.671 118.239ZM115.298 99.0329L113.058 98.4077L113.004 98.6007L112.984 98.8L115.298 99.0329ZM121.917 83.3457L123.89 84.5758L124.046 84.3264L124.134 84.0461L121.917 83.3457ZM125.441 69.4764L123.159 69.0266L123.158 69.0332L125.441 69.4764ZM132.135 99.9792C131.656 101.171 132.234 102.525 133.426 103.004C134.618 103.483 135.972 102.905 136.451 101.713L132.135 99.9792ZM103.86 185.992C105.75 187.348 105.75 187.348 105.751 187.347C105.751 187.347 105.751 187.346 105.751 187.346C105.752 187.345 105.753 187.344 105.753 187.343C105.755 187.341 105.757 187.338 105.76 187.334C105.765 187.327 105.771 187.318 105.78 187.306C105.797 187.282 105.821 187.248 105.851 187.205C105.911 187.118 105.997 186.994 106.105 186.834C106.322 186.514 106.627 186.052 106.993 185.468C107.724 184.303 108.706 182.645 109.711 180.66C111.701 176.735 113.886 171.344 114.294 165.889L111.974 165.716L109.655 165.543C109.315 170.1 107.443 174.848 105.563 178.557C104.633 180.39 103.726 181.923 103.053 182.995C102.717 183.53 102.441 183.948 102.252 184.229C102.157 184.369 102.084 184.475 102.036 184.544C102.012 184.578 101.994 184.603 101.983 184.618C101.978 184.626 101.974 184.631 101.972 184.634C101.971 184.636 101.97 184.637 101.97 184.637C101.97 184.637 101.97 184.637 101.97 184.637C101.97 184.637 101.971 184.636 101.971 184.636C101.971 184.636 101.971 184.636 103.86 185.992ZM111.974 165.716L114.294 165.889C114.683 160.683 114.298 154.07 113.833 148.846C113.6 146.215 113.342 143.902 113.143 142.246C113.044 141.418 112.959 140.753 112.898 140.293C112.868 140.064 112.844 139.885 112.828 139.764C112.819 139.703 112.813 139.656 112.808 139.624C112.806 139.608 112.805 139.596 112.803 139.588C112.803 139.583 112.802 139.58 112.802 139.578C112.802 139.577 112.802 139.576 112.802 139.575C112.802 139.575 112.801 139.574 112.801 139.574C112.801 139.574 112.801 139.574 110.498 139.898C108.195 140.222 108.195 140.222 108.195 140.222C108.195 140.222 108.195 140.222 108.195 140.222C108.195 140.222 108.195 140.223 108.195 140.224C108.196 140.225 108.196 140.228 108.196 140.231C108.197 140.238 108.199 140.248 108.201 140.263C108.205 140.291 108.211 140.334 108.219 140.392C108.234 140.506 108.257 140.677 108.286 140.899C108.345 141.344 108.428 141.991 108.525 142.801C108.72 144.421 108.972 146.685 109.2 149.258C109.661 154.439 110.014 160.735 109.655 165.543L111.974 165.716ZM110.498 139.898C112.804 139.594 112.804 139.594 112.804 139.594C112.804 139.594 112.804 139.595 112.804 139.595C112.804 139.595 112.804 139.595 112.804 139.595C112.804 139.594 112.804 139.593 112.804 139.591C112.803 139.587 112.802 139.58 112.801 139.571C112.799 139.551 112.795 139.521 112.79 139.479C112.78 139.396 112.765 139.27 112.747 139.104C112.71 138.771 112.661 138.279 112.609 137.657C112.506 136.411 112.395 134.649 112.369 132.599C112.317 128.464 112.61 123.315 113.904 118.891L111.671 118.239L109.439 117.586C107.956 122.658 107.663 128.339 107.718 132.659C107.746 134.837 107.863 136.71 107.973 138.041C108.029 138.708 108.082 139.24 108.123 139.61C108.143 139.794 108.16 139.938 108.172 140.038C108.178 140.088 108.183 140.127 108.186 140.155C108.188 140.168 108.19 140.179 108.191 140.187C108.191 140.191 108.191 140.194 108.192 140.197C108.192 140.198 108.192 140.199 108.192 140.2C108.192 140.2 108.192 140.201 108.192 140.201C108.192 140.201 108.192 140.202 110.498 139.898ZM111.671 118.239L113.911 118.866C115.707 112.451 116.945 105.893 117.612 99.2657L115.298 99.0329L112.984 98.8C112.344 105.161 111.155 111.455 109.432 117.612L111.671 118.239ZM115.298 99.0329C117.538 99.658 117.538 99.6583 117.538 99.6584C117.538 99.6584 117.538 99.6586 117.538 99.6586C117.538 99.6587 117.538 99.6586 117.538 99.6584C117.538 99.6579 117.539 99.6569 117.539 99.6554C117.54 99.6523 117.542 99.647 117.544 99.6396C117.548 99.6248 117.554 99.6014 117.564 99.5699C117.582 99.5067 117.609 99.4109 117.647 99.2852C117.721 99.0338 117.833 98.6634 117.98 98.1968C118.274 97.2629 118.709 95.9483 119.268 94.4358C120.394 91.3856 121.984 87.6339 123.89 84.5758L121.917 83.3457L119.943 82.1155C117.792 85.5668 116.073 89.6588 114.904 92.8248C114.315 94.4204 113.856 95.8071 113.544 96.7974C113.388 97.293 113.268 97.6904 113.186 97.9664C113.145 98.1044 113.114 98.2121 113.093 98.2866C113.082 98.3238 113.074 98.3528 113.068 98.3731C113.065 98.3832 113.063 98.3912 113.061 98.397C113.06 98.3999 113.06 98.4022 113.059 98.404C113.059 98.4049 113.059 98.4057 113.059 98.4063C113.058 98.4066 113.058 98.4069 113.058 98.4071C113.058 98.4074 113.058 98.4077 115.298 99.0329ZM121.917 83.3457L124.134 84.0461C125.599 79.4094 126.797 74.6929 127.724 69.9197L125.441 69.4764L123.158 69.0332C122.265 73.6326 121.11 78.1774 119.699 82.6452L121.917 83.3457ZM125.441 69.4764L127.723 69.9263C128.023 68.4011 128.594 68.0812 128.792 68.0058C129.079 67.8966 129.739 67.8596 130.741 68.468C132.727 69.6745 134.894 72.8216 134.846 77.1329L137.172 77.1587L139.497 77.1846C139.562 71.3701 136.662 66.6222 133.155 64.4922C131.41 63.4323 129.216 62.8665 127.136 63.6591C124.967 64.4855 123.657 66.498 123.159 69.0266L125.441 69.4764ZM137.172 77.1587L134.846 77.1329C134.731 87.5314 135.784 90.8932 132.135 99.9792L134.293 100.846L136.451 101.713C140.515 91.5928 139.388 87.0377 139.497 77.1846L137.172 77.1587ZM194.04 162.567C192.224 161.113 192.224 161.113 192.224 161.113C192.224 161.113 192.224 161.113 192.224 161.114C192.223 161.114 192.223 161.114 192.222 161.115C192.221 161.116 192.22 161.118 192.218 161.121C192.213 161.126 192.207 161.134 192.198 161.145C192.181 161.166 192.155 161.199 192.121 161.241C192.053 161.325 191.953 161.45 191.824 161.611C191.565 161.931 191.191 162.394 190.731 162.959C189.81 164.091 188.545 165.633 187.168 167.276C184.368 170.619 181.249 174.208 179.573 175.735L181.139 177.454L182.705 179.174C184.661 177.392 187.992 173.537 190.734 170.263C192.129 168.598 193.408 167.039 194.338 165.896C194.804 165.324 195.182 164.856 195.445 164.531C195.576 164.368 195.678 164.241 195.748 164.154C195.783 164.111 195.809 164.077 195.827 164.055C195.836 164.044 195.843 164.035 195.848 164.029C195.85 164.026 195.852 164.024 195.853 164.022C195.854 164.022 195.854 164.021 195.855 164.021C195.855 164.021 195.855 164.02 195.855 164.02C195.855 164.02 195.855 164.02 194.04 162.567ZM181.139 177.454L179.573 175.735C176.076 178.921 169.929 182.906 168.26 184.1L169.613 185.992L170.967 187.883C172.289 186.937 178.939 182.605 182.705 179.174L181.139 177.454ZM169.613 185.992L168.26 184.1C167.273 184.806 165.684 186.371 163.961 188.391C162.196 190.46 160.17 193.15 158.332 196.211L160.326 197.408L162.32 198.605C164.007 195.796 165.876 193.313 167.5 191.409C169.165 189.457 170.457 188.248 170.967 187.883L169.613 185.992Z"
        fill="currentColor"
      />
      <path
        d="M218.543 53.5286C221.903 52.7534 229.594 50.7358 230.931 60.0904C231.955 67.2634 221.903 71.8762 218.543 73.6851"
        stroke="currentColor"
        stroke-width="3.87627"
        stroke-linecap="round"
      />
      <path
        d="M220.589 136.629C216.408 138.022 212.924 134.538 212.924 129.661C212.924 125.758 215.711 123.854 217.105 123.389C217.105 123.157 217.384 122.553 218.499 121.996C219.614 121.438 222.215 125.015 223.376 126.873C223.841 129.661 223.934 135.514 220.589 136.629Z"
        fill="white"
      />
      <path
        d="M215.848 124.94C214.222 126.798 211.388 131.351 213.061 134.696C215.151 138.876 221.422 140.967 226.997 135.392C232.571 129.818 226.997 122.85 224.906 122.153"
        stroke="currentColor"
        stroke-width="3.87627"
        stroke-linecap="round"
      />
      <path
        d="M215.287 122.21C211.783 120.808 213.262 114.165 215.524 108.474C216.898 105.02 221.235 105.377 222.569 108.846L225.512 116.497C226.054 117.906 225.912 119.539 224.774 120.531C222.753 122.295 219.401 123.855 215.287 122.21Z"
        fill="white"
      />
      <path
        d="M219.659 103.128C216.887 104.976 210.572 112.981 213.344 119.634C216.809 127.951 223.825 122.669 227.899 117.555C231.922 112.505 231.922 110.354 229.978 106.466C228.315 103.139 226.513 102.308 225.82 102.308"
        stroke="currentColor"
        stroke-width="3.87627"
        stroke-linecap="round"
      />
      <path
        d="M216.702 102.394C213.63 100.973 214.285 95.532 215.841 90.5448C216.943 87.0109 221.336 87.0875 222.916 90.4354L225.793 96.5338C226.444 97.9124 226.419 99.5705 225.341 100.649C223.492 102.5 220.442 104.123 216.702 102.394Z"
        fill="white"
      />
      <path
        d="M218.475 86.6228C216.623 88.2348 213.057 92.7023 213.612 97.6764C214.307 103.894 219.865 104.585 222.644 103.894C224.867 103.341 229.455 99.5504 230.98 96.2947C232.928 92.1354 232.369 87.0373 226.812 83.1685C221.254 79.2997 218.938 79.2537 218.475 79.7142"
        stroke="currentColor"
        stroke-width="3.87627"
        stroke-linecap="round"
      />
      <rect opacity="0.55" x="140.752" y="41.6448" width="69.6838" height="108.625" rx="2.04952" fill="#F2F2F2" />
      <path
        d="M200.288 81.0279V123.399H150.683V63.4595H182.72L200.288 81.0279Z"
        fill="white"
        stroke="currentColor"
        stroke-width="4.13374"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M200.288 81.0281H182.72V63.4597"
        stroke="currentColor"
        stroke-width="4.13374"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M162.051 110.999H188.92"
        stroke="currentColor"
        stroke-width="4.13374"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M162.051 100.664H188.92"
        stroke="currentColor"
        stroke-width="4.13374"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M162.051 90.3298H188.92"
        stroke="currentColor"
        stroke-width="4.13374"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M162.051 79.9929H173.419"
        stroke="currentColor"
        stroke-width="4.13374"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.361 62.8374H54.1544V37.0439H28.361V62.8374ZM34.8093 43.4923H47.7061V56.389H34.8093V43.4923Z"
        fill="currentColor"
      />
      <path
        d="M28.3611 95.0835H54.1545V69.29H28.3611V95.0835ZM34.8094 75.7384H47.7062V88.6351H34.8094V75.7384Z"
        fill="currentColor"
      />
      <path
        d="M60.603 37.0437V62.8372H86.3965V37.0437H60.603ZM79.9481 56.3888H67.0514V43.4921H79.9481V56.3888Z"
        fill="currentColor"
      />
      <path d="M86.3969 88.6353H79.9485V95.0836H86.3969V88.6353Z" fill="currentColor" />
      <path d="M67.0514 69.29H60.603V75.7384H67.0514V69.29Z" fill="currentColor" />
      <path d="M73.5002 75.7388H67.0519V82.1871H73.5002V75.7388Z" fill="currentColor" />
      <path d="M67.0514 82.1875H60.603V88.6359H67.0514V82.1875Z" fill="currentColor" />
      <path d="M73.5002 88.6353H67.0519V95.0836H73.5002V88.6353Z" fill="currentColor" />
      <path d="M79.9501 82.1875H73.5017V88.6359H79.9501V82.1875Z" fill="currentColor" />
      <path d="M79.9501 69.29H73.5017V75.7384H79.9501V69.29Z" fill="currentColor" />
      <path d="M86.3969 75.7388H79.9485V82.1871H86.3969V75.7388Z" fill="currentColor" />
      <path
        d="M37.3451 25.6067H24.4484C20.887 25.6067 18 28.4937 18 32.0551V37.4287V49.2507"
        class="accent"
        stroke="currentColor"
        stroke-width="5.37364"
        stroke-linecap="round"
      />
      <path
        d="M18 88.9405L18 101.837C18 105.399 20.887 108.286 24.4484 108.286L28.7473 108.286L39.4946 108.286"
        class="accent"
        stroke="currentColor"
        stroke-width="5.37364"
        stroke-linecap="round"
      />
      <path
        d="M75.2689 25.6067H88.1656C91.727 25.6067 94.614 28.4937 94.614 32.0551V37.4287V49.2507"
        class="accent"
        stroke="currentColor"
        stroke-width="5.37364"
        stroke-linecap="round"
      />
      <path
        d="M94.614 88.9405L94.614 101.837C94.614 105.399 91.727 108.286 88.1656 108.286L83.8667 108.286L73.1195 108.286"
        class="accent"
        stroke="currentColor"
        stroke-width="5.37364"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
div {
  max-width: 280px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: rgb(var(--v-theme-on-surface-high-xqes));
    width: 100%;
    height: auto;

    .accent {
      color: rgb(var(--v-theme-brand-accent-xqes));
    }
  }
}
</style>
